import { Directive, ElementRef, EventEmitter, Output, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[observeElement]'
})
export class ObserveElementDirective implements AfterViewInit, OnDestroy {
  
  @Output() elementChanged = new EventEmitter<void>();
  private observer!: MutationObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.observer = new MutationObserver(() => {
      console.log('Element changed!');
      this.elementChanged.emit();
    });

    this.observer.observe(this.el.nativeElement, { childList: true, subtree: true, attributes: true });
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
